/*=====================================
    已上傳發票列表

    Author: Gray
    createtime: 2018 / 01 / 31
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
import filter from 'lodash/filter';
import actionCreators from 'actions/creators';
import classNames from "classnames";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import GLOBAL from 'jcolorglobal';
import 'react-day-picker/lib/style.css';
import debounce from 'lodash/debounce';
import CupoyRouter from "components/commons/router/CupoyRouter";
import PagedList from 'components/commons/PagedList';
import TurnkeyUploadLogListHeader from './TurnkeyUploadLogListHeader';
import TurnkeyUploadLogListItem from './TurnkeyUploadLogListItem';

/*--------------------------
    Variables
--------------------------*/
const SearchIcon = require('react-icons/lib/md/search');

/*--------------------------
    Main Component
--------------------------*/
class TurnkeyUploadLogListView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            keyword: '',
            currentKeyword: '',
            startDay: '',
            endDay: '',
            isFilterTime: false,
            yearmonth: undefined,
            isFilterYearmonth: false,
            srcType: GLOBAL.SRCTYPE.JCOLOR,
        };

        this.toggleIsFilterTime = this.toggleIsFilterTime.bind(this);
        this.onDaySelectChange = this.onDaySelectChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.renderCustomDayPickerOverlay = this.renderCustomDayPickerOverlay.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.enterSubmit = this.enterSubmit.bind(this);
        this.searchSubmit = this.searchSubmit.bind(this);
        this.deb_searchSubmit = debounce(this.searchSubmit, 1000);
        this.onYearmonthChange = this.onYearmonthChange.bind(this);
        this.toggleIsFilterYearmonth = this.toggleIsFilterYearmonth.bind(this);
        this.changeSrcType = this.changeSrcType.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.init(this.props);
        this.getTurnkeyUploadLogYearmonthList();
    }

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    // ------------------------------
    // init
    // ------------------------------
    init(props) {

        if (!props.match) {
            return;
        }

        const page = props.match.params.page;
        const location = props.location;
        var startDay = this.state.startDay;
        var endDay = this.state.endDay;
        var isFilterTime = false;
        var keyword = this.state.keyword;
        var currentKeyword = this.state.currentKeyword;
        const old_yearmonth = this.state.yearmonth;
        var yearmonth = undefined;
        var isFilterYearmonth = false;
        var old_srcType = this.state.srcType;
        var srcType = GLOBAL.SRCTYPE.JCOLOR;
        var isChange = false;

        if(location && location.search) {
            const querys = parse(location.search.substr(1));

            var starttime = parseInt(querys.starttime, 10);
            var endtime = parseInt(querys.endtime, 10);
            var old_starttime = startDay ? new Date(startDay).getTime() : undefined;
            var old_endtime = endDay ? new Date(startDay).getTime() : undefined;

            if(starttime !== old_starttime) {
                startDay = starttime > 0 ? new Date(starttime) : undefined;
                isChange = true;
            }

            if(endtime !== old_endtime) {
                endDay = endtime > 0 ? new Date(endtime) : undefined;
                isChange = true;
            }

            isFilterTime = starttime || endtime;

            var new_keyword = querys.keyword ? querys.keyword.trim() : '';

            if(new_keyword !== currentKeyword) {
                currentKeyword = new_keyword;
                keyword = keyword ? keyword : currentKeyword;
                isChange = true;
            }

            yearmonth = querys.yearmonth;

            if(yearmonth !== old_yearmonth) {
                isChange = true;
            }

            isFilterYearmonth = !!yearmonth;

            srcType = querys.srcType;

            if(srcType && srcType !== GLOBAL.SRCTYPE.JCOLOR && srcType !== GLOBAL.SRCTYPE.SHEN) {
                srcType = GLOBAL.SRCTYPE.JCOLOR;
            }

            if(old_srcType !== srcType) {
                isChange = true;
            }
        }

        isChange = isChange || this.state.page !== page;

        if (!isChange) {
            return;
        }

        this.setState({
            page: page,
            isFilterTime: isFilterTime,
            startDay: startDay,
            endDay: endDay,
            keyword: keyword,
            currentKeyword: currentKeyword,
            yearmonth: yearmonth,
            isFilterYearmonth: isFilterYearmonth,
            srcType: srcType,
        });
    }

    // ------------------------------
    // 取得開立發票存在的期別列表 
    // ------------------------------
    getTurnkeyUploadLogYearmonthList() {

        if(!Array.isArray(this.props.yearmonthList) || this.props.yearmonthList.length === 0) {
            this.props.turnkeyUploadLogActions.getTurnkeyUploadLogYearmonthList();
        }
    }

    // ------------------------------
    // 切換過濾時間
    // ------------------------------
    toggleIsFilterTime(isFilterTime) {

        this.setState({
            isFilterTime: isFilterTime,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 時間變動
    // ------------------------------
    onDaySelectChange(selectedDay, modifiers, statekey) {

        this.setState({
            [statekey]: selectedDay,
            isFilterTime: true,
        }, () => {
            this.onFilterChange();
        });
    }

    // ------------------------------
    // 任何過濾條件變動
    // ------------------------------
    onFilterChange() {

        const {
            startDay,
            endDay,
            isFilterTime,
            currentKeyword,
            yearmonth,
            isFilterYearmonth,
            srcType,
        } = this.state;

        var querys = {};

        if(isFilterTime) {

            var new_startDay = new Date(startDay);
            var new_endDay = new Date(endDay);


            if(!isNaN(new_startDay)) {
                querys.starttime = new_startDay.getTime();
            }

            if(!isNaN(new_endDay)) {
                querys.endtime = new_endDay.getTime();
            }
        }

        if(currentKeyword && currentKeyword.trim()) {
            querys.keyword = currentKeyword;
        }

        if(isFilterYearmonth) {
            querys.yearmonth = yearmonth;
        }

        if(srcType && srcType === GLOBAL.SRCTYPE.SHEN) {
            querys.srcType = srcType;
        }

        const statename = CupoyRouter.STATES.TURNKEYUPLOADLOG_LIST;
        const params = {
            page: 1,
        };

        this.props.webActions.cupoyStateGo(statename, params, querys);
    }

    // ------------------------------
    // 搜尋input變動
    // ------------------------------
    onInputChange(event) {

        event.preventDefault();

        const keyword = event.target.value;

        this.setState({
            keyword: keyword,
        });

        if(!keyword) {
            this.deb_searchSubmit('');
        } else {
            this.deb_searchSubmit(keyword);
        }
    }
    
    // ------------------------------
    // 搜尋按下enter
    // ------------------------------
    enterSubmit(event) {

        if(event && event.key === 'Enter') {
            event.preventDefault();
            this.searchSubmit(this.state.keyword);
        }
    }

    // ------------------------------
    // 搜尋
    // ------------------------------
    searchSubmit(keyword) {

        this.setState({
            currentKeyword: keyword,
        }, () => {
            this.onFilterChange();
        });
    }

    // ------------------------------
    // 期別更動
    // ------------------------------
    onYearmonthChange(event) {

        var yearmonth = event.target.value;

        this.setState({
            yearmonth: yearmonth,
            isFilterYearmonth: !!yearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 切換過濾期別
    // ------------------------------
    toggleIsFilterYearmonth(isFilterYearmonth) {

        this.setState({
            isFilterYearmonth: isFilterYearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 切換來源
    // ------------------------------
    changeSrcType(srcType) {

        if(srcType === this.state.srcType) {
            return;
        }

        this.setState({
            srcType: srcType,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({ classNames, selectedDay, children }) {

        return (
            <div className={classNames.overlayWrapper} style={{ position: 'absolute', lineHeight: 'normal' }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    // ------------------------------
    // render filter區塊
    // ------------------------------
    renderFilterContent(querys) {

        const {
            isFilterTime,
            startDay,
            endDay,
            yearmonth,
        } = this.state;

        const {
            yearmonthList,
        } = this.props;

        const startDayValue = startDay ? formatDate(startDay, 'YYYY/MM/DD') : '';
        const endDayValue = endDay ? formatDate(endDay, 'YYYY/MM/DD') : '';

        return (
            <div className="form">
                <table className="form-table">
                    <tbody>
                        <tr className="form-row">
                            <td className="form-col label-text">開立時間</td>
                            <td className="form-col">
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': !isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(false)}
                                >
                                    不限
                                </div>
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(true)}
                                >
                                    指定區間
                                </div>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'startDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={startDayValue}
                                    dayPickerProps={{
                                        selectedDays: startDay,
                                    }}
                                    placeholder="起"
                                />
                                <span className="line"></span>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'endDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={endDayValue}
                                    dayPickerProps={{
                                        selectedDays: endDay,
                                    }}
                                    placeholder="訖"
                                />
                            </td>
                        </tr>
                        {yearmonthList.length > 0 ?
                            <tr className="form-row">
                                <td className="form-col label-text">發票期別</td>
                                <td className="form-col">
                                    <div className="form-select fileter-large-content">
                                        <select value={yearmonth} onChange={(event) => this.onYearmonthChange(event)}>
                                            <option value={''} key={''}>---</option>
                                            {yearmonthList.map((_yearmonth, index)=> {
                                                return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                            })}
                                        </select>
                                        <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                    </div>
                                </td>
                            </tr>
                            :
                            null
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { page, keyword, srcType } = this.state;
        const { pageLen, totalCount, location } = this.props;
        const num_page = Number(page);
        var querys = {};

        if(location && location.search) {
            querys = parse(location.search.substr(1));
        }

        return (
            <div id="invoice">
                <div className="header-bar mix">
                    <div className="tabs">
                        <h2 className="title">已上傳發票列表</h2>
                        <ul className="tab-list">
                            <li 
                                className={classNames("tab-item", {
                                   'active': !srcType || srcType === GLOBAL.SRCTYPE.JCOLOR,
                                })}
                                onClick={() => this.changeSrcType(GLOBAL.SRCTYPE.JCOLOR)}
                            >
                                <a>捷可印發票</a>
                            </li>
                            <li 
                                className={classNames("tab-item", {
                                   'active': srcType === GLOBAL.SRCTYPE.SHEN,
                                })}
                                onClick={() => this.changeSrcType(GLOBAL.SRCTYPE.SHEN)}
                            >
                                <a>代拋發票</a>
                            </li>
                        </ul>
                    </div>
                    <div className="search-bar">
                        <input 
                            type="search"
                            placeholder="搜尋發票號碼"
                            value={keyword}
                            onChange={(event) => this.onInputChange(event)}
                            onKeyPress={(event) => this.enterSubmit(event)}
                        />
                        <div className="search-icon"><SearchIcon/></div>
                    </div>
                </div>
                <PagedList
                    page={num_page}
                    pageLen={pageLen}
                    totalCount={totalCount}
                    colspan={4}
                    querys={querys}
                    getListItemFrom={(start, querys) => {

                        var invoiceNumber = querys.keyword;
                        // 去掉字軌
                        if(invoiceNumber) {
                            if(invoiceNumber.length === 11) {
                                invoiceNumber = invoiceNumber.substr(3);
                            } else if(invoiceNumber.length === 10) {
                                invoiceNumber = invoiceNumber.substr(2);
                            }
                        }

                        var srcType = querys.srcType;

                        switch(srcType) {
                            case GLOBAL.SRCTYPE.JCOLOR:
                            case GLOBAL.SRCTYPE.SHEN:
                                break;
                            default:
                                srcType = GLOBAL.SRCTYPE.JCOLOR;
                                break;
                        }

                        return this.props.turnkeyUploadLogActions.getTurnkeyUploadLogList({ 
                            start: start,
                            starttime: querys.starttime,
                            endtime: querys.endtime,
                            yearmonth: querys.yearmonth,
                            invoiceNumber: invoiceNumber,
                            srcType: srcType,
                        });
                    }}
                    pageStateName={CupoyRouter.STATES.TURNKEYUPLOADLOG_LIST}
                    getItemsInRanage={(start, end) => {
                        return filter(this.props.turnkeyUploadLogList, (item, index) => {
                            return Number(index) >= start && Number(index) < (end);
                        });
                    }}
                    renderItemHeaderRow={(item, index) => {
                        return <TurnkeyUploadLogListHeader/>;
                    }}
                    renderItemRow={(item, index, start) => {
                        return <TurnkeyUploadLogListItem
                            key={item}
                            item={this.props.turnkeyUploadLogs[item]}
                            start={start}
                            index={index}
                        />;
                    }}
                    renderFilterContent={() => {
                        return this.renderFilterContent(querys);
                    }}
                />
            </div>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function (state) {
    return {
        turnkeyUploadLogList: state.turnkeyUploadLog.turnkeyUploadLogList,
        turnkeyUploadLogs: state.turnkeyUploadLog.turnkeyUploadLogs,
        pageLen: state.turnkeyUploadLog.pageLen,
        totalCount: state.turnkeyUploadLog.totalCount,
        yearmonthList: state.turnkeyUploadLog.yearmonthList,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
    return {
        turnkeyUploadLogActions: bindActionCreators(actionCreators.turnkeyUploadLogActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch), 
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(TurnkeyUploadLogListView);


// WEBPACK FOOTER //
// ./src/components/turnkeyuploadlog/TurnkeyUploadLogListView.jsx